import '../Shared/common.scss';
import { InputLabel, OutlinedInput, InputAdornment } from "@mui/material";
import { Controller } from "react-hook-form";

const MileageInput = ({
    control,
    label,
    name = "mileage",
    symbol = "miles",
    size = "medium",
}: any & {
    label?: string;
    name?: string;
    symbol?: string;
    size?: string;
}) => {

    return (
        <>
            <Controller
                name={name}
                control={control}
                render={({
                    field: { onChange, value },
                    fieldState: { error },
                    formState,
                }) => (
                    <>
                        <InputLabel htmlFor="outlined-adornment">{label}</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment"
                            endAdornment={<InputAdornment position="end"><span className='small'>{symbol}</span></InputAdornment>}
                            name={name}
                            label={label}
                            value={value}
                            type='number'
                            onChange={onChange}
                            inputProps={{
                                min: 0, style: { textAlign: 'right' }
                            }}
                            size={size}
                        />
                    </>

                )}
            />
        </>
    );
};

export default MileageInput;
